/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsThumbDown: {
  name: 'thumb-down';
  data: string;
} = {
  name: 'thumb-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.677.5a1.5 1.5 0 0 0-1.393.943L.607 5.636a1.5 1.5 0 0 0-.107.557V8A1.5 1.5 0 0 0 2 9.5h4a.5.5 0 0 1 .5.5v2.586c0 1.336 1.616 2.005 2.56 1.06l3-3a1.5 1.5 0 0 0 .44-1.06V2A1.5 1.5 0 0 0 11 .5H3.677Zm-.464 1.314a.5.5 0 0 1 .464-.314H11a.5.5 0 0 1 .5.5v7.586a.5.5 0 0 1-.146.353l-3 3a.5.5 0 0 1-.854-.353V10A1.5 1.5 0 0 0 6 8.5H2a.5.5 0 0 1-.5-.5V6.193a.5.5 0 0 1 .036-.186l1.677-4.193ZM15.5 1a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0V1Z" fill="currentColor"/></svg>`,
};
